var _$ProviderView_127=_$ProviderView_125;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJyZXF1aXJlIl0sIm1hcHBpbmdzIjoiQUFBQUEsc0JBQU9DLENBQVVDLGtCQUFRLENBQUEiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==